import api from 'Application/api/api';

const deleteTranche = (signal, id) =>
	api.delete(`/tranches/${id}`, {
		signal,
	});

export default deleteTranche;
